import { action, observable } from 'mobx';
import * as PRJAPI from 'cd-eft/services/eftPrjAdminApi';
import { MetaDataDto } from 'cd-eft/_codegen_/openapi-generator/eft-prjadmin';
import { isValidUrl } from 'cd-eft/utils/stringUtilities';

export class MetadataVM {
  @observable metadata: MetaDataDto[] = [];

  @observable metadataStanzas: string[] = [
    'Data Type - Soil',
    'Data Type - Land Use/Land Cover',
    'Data Type - Rainfall',
    'Data Type - Rainfall Discharge',
    'Data Type - Basemaps',
  ];
  @observable metadataLabelsCol1: string[] = [
    //'dataType',
    'publicationDate',
    'refreshFrequency',
    'projection',
    'resolution',
    'elevationUnits',
    'scale',
    'dataOwner',
  ];
  @observable metadataLabelsCol2: string[] = ['lastLoadedDate', 'dataOwnerContact'];

  @action.bound validateDate(value: string | null) {
    if (value !== null && isNaN(Date.parse(value))) {
      return 'N/A';
    } else {
      return value;
    }
  }

  @action.bound makeLabelPretty(uglyLabel) {
    let prettyLabel = '';
    const uglySplit = uglyLabel.split(/(?=[A-Z])/);
    for (const item of uglySplit) {
      prettyLabel += item[0].toUpperCase() + item.substring(1) + ' ';
    }

    if (prettyLabel.includes('Last Loaded Date')) {
      return 'Updated ';
    } else {
      return prettyLabel;
    }
  }

  @action.bound validURL(str) {
    if (isValidUrl(str)) return str;
    else return 'https://www.spatialfront.com/pages/index.html';
  }

  @action.bound async getMetadata() {
    const response = await PRJAPI.MetadataController.getAllMetadataUsingGET();
    const data = response.data;
    this.metadata = data;
  }
}
